<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="400"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Создание прайс-листа</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-7">
        <v-form v-model="isValid" ref="form">
          <v-text-field
            label="Название *"
            v-model="name"
            filled
            :rules="[v => !!v || 'Введите название прайс-листа.']"
          ></v-text-field>

          <v-select
            label="Копировать прайс-лист *"
            v-model="originalId"
            filled
            :items="prices"
            item-text="name"
            item-value="_id"
            clearable
            :rules="[v => !!v || 'Выберите прайс-лист.']"
          ></v-select>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save"
          :disabled="loadingCreate"
          :loading="loadingCreate"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'price-create',

  data() {
    return {
      activeMode: false,
      isValid: false,

      name: '',
      originalId: null,
    }
  },

  methods: {
    save() {
      this.$refs.form.validate();
      if (this.isValid) {
        let price = {
          name: this.name
        }
        if (this.originalId) price.originalId = this.originalId;
        this.$store.dispatch('prices/create', price)
        .then(res => {
          this.$store.dispatch('showMessage', res.message);
          this.closeForm();
        })
        .catch(err => {
          this.$store.dispatch('showMessage', err.message);
        });
      }
    },

    closeForm() {
      this.activeMode = false;
      this.name = '';
      this.originalId = null;
      this.$refs.form.resetValidation();
    },
  },

  computed: {
    ...mapState('prices', ['allPrices']),
    ...mapGetters('prices', ['loadingCreate']),
    prices() {
      return [
        {
          name: 'БАЗОВЫЙ',
          _id: '5f6f113bd59e76193a893faa'
        },
        ...this.allPrices.filter(x => x._id != '5f6f113bd59e76193a893faa')
      ]
    }
  }
}
</script>